import { BoxWrapper, Button } from 'components/Base';
import React, { useState } from 'react';
import { CustomerType } from 'store/modules/Customers/types';
import { reduxForm, Field, Form } from 'redux-form';
import { compose } from 'ramda';
interface RiskToleranceReportProps {
  customers: CustomerType[];
  onClose: Function;
  downloadReport: Function;
}

const RiskToleranceReport = ({
  customers,
  onClose,
  downloadReport
}: RiskToleranceReportProps) => {
  const [selectedCustomerId, setSelectedCustomerId] = useState(customers[0].id);
  const [jointCustomer, setJointCustomer] = useState(customers[0].is_jointed);

  const setReportData = (customerId: number, is_jointed: boolean) => {
    setSelectedCustomerId(customerId);
    setJointCustomer(is_jointed);
  };

  const radioButtons = customers.map((customer: any) => {
    return (
      <label key={customer.id} style={{ cursor: 'pointer' }}>
        <Field
          name={`hquestion`}
          component="input"
          type="radio"
          checked={customer.id === selectedCustomerId}
          value={`${customer.id}`}
          onClick={() => setReportData(customer.id, customer.is_jointed)}
        />
        {customer.display_name ||
          customers
            .map(customer => customer.display_name)
            .filter(Boolean)
            .join(' & ')}
      </label>
    );
  });

  return (
    <BoxWrapper
      title="Download Risk Analysis Report for:"
      closeModal={() => onClose()}
    >
      <div
        style={{
          padding: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <Form>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              fontSize: '1rem'
            }}
          >
            {radioButtons}
          </div>
        </Form>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            onClick={() => {
              downloadReport(selectedCustomerId, jointCustomer, 'pdf');
              onClose();
            }}
          >
            Download as PDF
          </Button>
          <Button
            key="Download as Word button"
            onClick={() => {
              downloadReport(selectedCustomerId, jointCustomer, 'word');
              onClose();
            }}
          >
            Download as Word
          </Button>
        </div>
      </div>
    </BoxWrapper>
  );
};

export default compose(
  reduxForm({
    form: 'ipsPrint',
    enableReinitialize: true
  })
)(RiskToleranceReport);
